import { render, staticRenderFns } from "./OsAppusersOverview.vue?vue&type=template&id=1ee10b21&scoped=true"
import script from "./OsAppusersOverview.vue?vue&type=script&lang=ts"
export * from "./OsAppusersOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee10b21",
  null
  
)

export default component.exports